<template>
  <v-card-text class="safir_device">
    <div class="choose-select">
      <v-select
        :items="post_items"
        :label="$t('select')"
        item-text="label"
        item-value="value"
        single-line
        v-model="selected_branch"
      >
      </v-select>
    </div>
    <v-card-text>
      <v-autocomplete
        v-model="model"
        :items="entries"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        hide-no-data
        hide-selected
        item-text="Description"
        item-value="API"
        :label="$t('searchDriver')"
        :placeholder="$t('search')"
        return-object
      ></v-autocomplete>
    </v-card-text>
    <v-divider></v-divider>
    <div class="chat-list" v-for="item in request_items" :key="item.Id">
      <div class="chat-prev" v-on:click="goToDetail(item)">
        <v-card
          :color="item.color"

        >
          <div class="flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="headline"
                v-text="item.RequestName"
              ></v-card-title>

              <v-card-subtitle v-text="item.RequestCode"></v-card-subtitle>
              <v-card-text v-text="item.ReqReceivDate"></v-card-text>

              <v-card-actions>
                <div class="text-center">
                  <v-chip v-for="item_chip in item.PredefinedGlobal"
                          class="ma-1"
                          color="primary"
                  >
                    {{item_chip.Text}}:{{item_chip.Value}}
                  </v-chip>

                  <v-chip
                    v-for="item_chip in item.PredefinedChecked"
                    class="ma-1"
                    color="primary"
                  >
                    {{item_chip.Text}}:{{item_chip.Value}}

                  </v-chip>
                </div>
              </v-card-actions>
            </div>

          </div>
          <label>{{get_request_address(item)}}</label>
          <label>{{item.StatusName}}</label>
        </v-card>

      </div>

    </div>

  </v-card-text>

</template>
<script>
  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        post_items: [],
        safir_items: [],
        selected_post: 0,
        selected_branch: 0,
        selected_safir_id: 0,
        request_items: [],

        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        model: null,
        search: null,
      }
    },
watch: {
      selected_safir_id: function () {
        this.get_pre_requests()
      },
      selected_branch: function () {
        this.get_pre_requests()
      },
      model: function () {
        var self = this
        this.selected_safir_id = 0
        this.safir_items.forEach(function (number) {
          if (self.model == number.UserName) {
            self.selected_safir_id = number.Id
          }
          // this.entries.push(number.UserName);
        })
      },
      search (val) {
        this.get_safir_by_text(val)
      },

    },
mounted () {
      this.get_posts()
    },

    methods: {

      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({ name: 'ViewRequest', params: { rec_id: item.Id } })
        } else {
          this.$router.push({ name: 'ViewPreRequest', params: { rec_id: item.Id } })
        }
      },
      get_safir_by_text (search_text) {
        this.isLoading = true

        var self = this
        const send_data = {
          Txt: search_text,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPeykerByText', send_data, { show_pros: false })
          .then(response => {
            // self.count = count
            self.safir_items = response.data.Payks
            self.safir_items.forEach(function (number) {
              // var obj = {label: number.BranchName, value: number.Id}
              self.entries.push(number.UserName)
            })
            // UserName
            self.isLoading = false
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_posts () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetBranches', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.branches.forEach(function (number) {
                var obj = { label: number.BranchName, value: number.Id }
                self.post_items.push(obj)
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests () {
        this.request_items = []
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: this.selected_safir_id,
          BranchId: this.selected_branch,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserDevicesDelivery', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_items = response.data.requests
              // console.log("salam")
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
